import * as React from "react";
import { IconProps } from "./IconProps";

export const IconExclude = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_14159_31472)">
          <path
            d="M13.6568 2.35601C12.1557 0.855767 10.1201 0.0132912 7.99778 0.0139164C5.8755 0.0145415 3.84038 0.858216 2.34014 2.35934C0.839898 3.86047 -0.00257788 5.89608 -0.00195278 8.01836C-0.00132767 10.1407 0.842347 12.1758 2.34347 13.676C3.82224 15.1232 5.79925 15.9488 7.86803 15.9832C9.93682 16.0175 11.9401 15.258 13.4661 13.8607C14.1349 13.2352 14.692 12.5002 15.1135 11.6873C15.5163 10.9053 15.7866 10.0618 15.9135 9.19134C15.9707 8.80217 15.9996 8.40936 16.0001 8.01601C16.003 6.96452 15.7974 5.9229 15.3952 4.95139C14.9929 3.97987 14.4021 3.09774 13.6568 2.35601ZM3.52814 3.52801C4.59527 2.48299 5.99358 1.84306 7.48198 1.71856C8.97037 1.59407 10.4556 1.9928 11.6815 2.84601C11.702 2.86099 11.719 2.88024 11.7314 2.90243C11.7438 2.92463 11.7512 2.94924 11.7532 2.97458C11.7552 2.99992 11.7516 3.02539 11.7428 3.04922C11.734 3.07306 11.7201 3.09471 11.7021 3.11267L3.11147 11.7073C3.09345 11.7252 3.07179 11.739 3.04797 11.7477C3.02414 11.7565 2.99871 11.76 2.97341 11.758C2.9481 11.7561 2.92352 11.7487 2.90133 11.7364C2.87913 11.7241 2.85986 11.7071 2.84481 11.6867C1.97466 10.4659 1.56579 8.97601 1.69091 7.48208C1.81604 5.98815 2.46705 4.58705 3.52814 3.52801ZM12.4995 12.504C11.4393 13.5615 10.0393 14.2101 8.54708 14.3349C7.05486 14.4597 5.56658 14.0527 4.34547 13.186C4.3249 13.1711 4.3078 13.1519 4.29535 13.1297C4.28291 13.1075 4.27542 13.0829 4.27339 13.0576C4.27136 13.0322 4.27485 13.0068 4.28361 12.9829C4.29237 12.959 4.3062 12.9374 4.32414 12.9193L12.9155 4.32401C12.9335 4.30613 12.9552 4.29235 12.979 4.2836C13.0028 4.27485 13.0282 4.27134 13.0535 4.2733C13.0788 4.27526 13.1034 4.28265 13.1256 4.29497C13.1478 4.30728 13.1671 4.32424 13.1821 4.34467C14.0526 5.56537 14.4618 7.0553 14.337 8.54937C14.2121 10.0434 13.5612 11.4448 12.5001 12.504H12.4995Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_14159_31472">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
